module.exports = __webpack_public_path__ + "static/media/technology-physiological.43e30096.png";